import React from "react";

const timelockStakingFaq = [
  {
    title: "What does it mean to timelock ETH when staking ETH?",
    description: (
      <p>
        When you timelock ETH while staking with us, it means you're choosing to
        commit your Ethereum (ETH) holdings for a specific duration, such as 1
        year, 2 years, 3 years, etc. During this period, you won't be able to
        unstake your ETH. However, in exchange for this commitment, you'll enjoy
        lower staking fees and other perks exclusive to our platform. This
        option provides you with benefits tailored to long-term stakers who are
        willing to commit their ETH for a set period.
      </p>
    ),
  },
  {
    title: "Will I be able to withdraw my funds?",
    description: (
      <p>
        If you choose to timelock your ETH while staking with us, you won't be
        able to withdraw your funds during the specified timelock period. We've
        implemented this restriction on our platform to ensure the integrity of
        the staking process and to provide benefits such as lower staking fees
        and other perks. However, once the timelock period expires, you'll
        regain the ability to Unstake your ETH and then withdraw or Trade your
        ETH.
      </p>
    ),
  },
];

export default timelockStakingFaq;
